<div class="br-dialog-shell record-dialog-shell">
  <header class="br-dialog-header">
    <h2 mat-dialog-title class="br-dialog-title">{{ data.title }}</h2>
    <button type="button" class="br-btn-close" mat-dialog-close aria-label="Close"></button>
  </header>

  <mat-dialog-content class="br-dialog-body">
    <div class="record-form">
      <div class="record-field" *ngFor="let field of fields">
        <label class="record-label" [for]="'record-field-' + field.key">
          {{ field.label }}
          <span *ngIf="field.isRequired" class="br-required-mark" aria-hidden="true">*</span>
        </label>

        <ng-container [ngSwitch]="field.dataType">
          <input
              *ngSwitchCase="'shortText'"
              class="record-control"
              [id]="'record-field-' + field.key"
              [(ngModel)]="values[field.key]"
              [required]="field.isRequired"
              [attr.aria-required]="field.isRequired"
              [attr.aria-invalid]="missing(field)"
              maxlength="512" />

          <input
              *ngSwitchCase="'number'"
              class="record-control"
              [id]="'record-field-' + field.key"
              type="number"
              step="any"
              [(ngModel)]="values[field.key]"
              [required]="field.isRequired"
              [attr.aria-required]="field.isRequired"
              [attr.aria-invalid]="missing(field)" />

          <input
              *ngSwitchCase="'date'"
              class="record-control"
              [id]="'record-field-' + field.key"
              type="date"
              [(ngModel)]="values[field.key]"
              [required]="field.isRequired"
              [attr.aria-required]="field.isRequired"
              [attr.aria-invalid]="missing(field)" />

          <select
              *ngSwitchCase="'choice'"
              class="record-control record-select"
              [id]="'record-field-' + field.key"
              [(ngModel)]="values[field.key]"
              [required]="field.isRequired"
              [attr.aria-required]="field.isRequired"
              [attr.aria-invalid]="missing(field)">
            <option [ngValue]="null">{{ field.isRequired ? 'Select an option' : 'None' }}</option>
            <option
                *ngFor="let option of field.options"
                [ngValue]="option.key"
                [disabled]="!option.isActive">
              {{ option.label }}
            </option>
          </select>

          <mat-checkbox
              *ngSwitchCase="'boolean'"
              class="record-checkbox"
              [id]="'record-field-' + field.key"
              [(ngModel)]="values[field.key]">
            Yes
          </mat-checkbox>
        </ng-container>

        <span class="record-error" *ngIf="missing(field)">This field is required.</span>
      </div>
    </div>
  </mat-dialog-content>

  <footer class="br-dialog-footer">
    <button type="button" class="br-btn br-btn--outline-secondary" mat-dialog-close>
      Cancel
    </button>
    <button type="button" class="br-btn br-btn--primary" (click)="save()">
      Save
    </button>
  </footer>
</div>
